<!-- Navigation -->
<nav
  class="fixed top-0 left-0 right-0 z-50 bg-background/95 dark:bg-slate-900/20 backdrop-blur-sm border-b border-border/40">
  <div class="max-w-6xl mx-auto px-6 lg:px-8">
    <div class="flex justify-between items-center h-16">
      <!-- Logo -->
      <div class="flex items-center space-x-2">
        <div
          class="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center shadow-lg">
          <svg
            class="w-5 h-5 text-white"
            fill="currentColor"
            viewBox="0 0 24 24">
            <path d="M20 6L9 17l-5-5" />
          </svg>
        </div>
        <span
          class="text-xl font-semibold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent"
          >B2B CRM</span
        >
      </div>

      <!-- Navigation Links -->
      <div class="hidden md:flex items-center space-x-8">
        <a
          href="/#features"
          class="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >Features</a
        >
        <a
          href="/#pricing"
          class="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >Pricing</a
        >
        <a
          href="/about"
          class="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >About</a
        >
        <a
          href="/contact"
          class="text-sm text-foreground font-medium"
          >Contact</a
        >
      </div>

      <!-- Auth Links & Theme Toggle -->
      <div class="hidden md:flex items-center space-x-4">
        <app-theme-toggle
          (themeChange)="onThemeChange($event)"></app-theme-toggle>
        <a
          href="/auth/sign-in"
          class="text-sm text-muted-foreground hover:text-foreground transition-colors"
          >Sign In</a
        >
        <a
          href="/auth/sign-up"
          class="bg-foreground text-background px-4 py-2 rounded-md text-sm font-medium hover:bg-foreground/90 transition-colors"
          >Get Started</a
        >
      </div>

      <!-- Mobile Menu Button -->
      <div class="md:hidden flex items-center space-x-2">
        <app-theme-toggle
          (themeChange)="onThemeChange($event)"></app-theme-toggle>
        <button
          class="p-2 rounded-md text-muted-foreground hover:text-foreground hover:bg-accent transition-colors"
          (click)="toggleMobileMenu()">
          <svg
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h16" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</nav>

<!-- Mobile Menu -->
<div
  class="md:hidden fixed inset-0 z-40 bg-background/95 backdrop-blur-sm transition-opacity duration-300"
  [class.opacity-0]="!isMobileMenuOpen"
  [class.opacity-100]="isMobileMenuOpen"
  [class.pointer-events-none]="!isMobileMenuOpen"
  [class.pointer-events-auto]="isMobileMenuOpen"
  *ngIf="isMobileMenuOpen">
  <div class="flex flex-col h-full pt-16">
    <div class="flex-1 px-6 py-8 space-y-8">
      <!-- Mobile Navigation Links -->
      <div class="space-y-6">
        <a
          href="/#features"
          class="block text-lg text-muted-foreground hover:text-foreground transition-colors"
          (click)="toggleMobileMenu()"
          >Features</a
        >
        <a
          href="/#pricing"
          class="block text-lg text-muted-foreground hover:text-foreground transition-colors"
          (click)="toggleMobileMenu()"
          >Pricing</a
        >
        <a
          href="/about"
          class="block text-lg text-muted-foreground hover:text-foreground transition-colors"
          (click)="toggleMobileMenu()"
          >About</a
        >
        <a
          href="/contact"
          class="block text-lg text-foreground font-medium"
          (click)="toggleMobileMenu()"
          >Contact</a
        >
      </div>

      <!-- Mobile Auth Links -->
      <div class="space-y-4 pt-8 border-t border-border">
        <a
          href="/auth/sign-in"
          class="block text-lg text-muted-foreground hover:text-foreground transition-colors"
          (click)="toggleMobileMenu()"
          >Sign In</a
        >
        <a
          href="/auth/sign-up"
          class="block bg-foreground text-background px-6 py-3 rounded-lg text-lg font-medium hover:bg-foreground/90 transition-colors text-center"
          (click)="toggleMobileMenu()"
          >Get Started</a
        >
      </div>
    </div>
  </div>
</div>

<particles [quantity]="200">
  <!-- Hero Section -->
  <section class="pt-24 pb-12 px-6 lg:px-8 bg-gradient-to-br from-slate-50 via-blue-50 to-purple-50 dark:from-slate-900 dark:via-blue-900/20 dark:to-purple-900/20">
    <div class="max-w-4xl mx-auto text-center">
      <div class="hero-content space-y-8">
        <div class="space-y-4">
          <div
            class="inline-flex items-center px-4 py-2 rounded-full bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-200 text-sm font-medium">
            <svg
              class="w-4 h-4 mr-2"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24">
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
            </svg>
            Get in Touch
          </div>
          <h1
            class="text-5xl md:text-6xl lg:text-7xl font-light text-foreground leading-tight tracking-tight">
            Contact our
            <br />
            <span
              class="font-medium bg-gradient-to-r from-blue-600 via-purple-600 to-blue-800 bg-clip-text text-transparent"
              >expert team</span
            >
          </h1>
        </div>
        <p
          class="text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed">
          Have questions about B2B CRM? Need a custom solution for your business? We're here to help you succeed.
        </p>
      </div>
    </div>
  </section>
</particles>

<!-- Contact Section -->
<section class="py-20 px-6 lg:px-8 bg-background">
  <div class="max-w-7xl mx-auto">
    <div class="grid lg:grid-cols-2 gap-16">
      <!-- Contact Form -->
      <div>
        <div class="bg-card rounded-2xl shadow-xl border border-border p-8">
          <div class="mb-8">
            <h2 class="text-3xl font-light text-foreground mb-4">Send us a message</h2>
            <p class="text-muted-foreground">
              Fill out the form below and we'll get back to you within 24 hours.
            </p>
          </div>

          <form (ngSubmit)="onSubmit()" #contactFormRef="ngForm" class="space-y-6">
            <!-- Name and Email Row -->
            <div class="grid md:grid-cols-2 gap-4">
              <div>
                <label for="name" class="block text-sm font-medium text-foreground mb-2">
                  Name *
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  [(ngModel)]="contactForm.name"
                  required
                  class="w-full px-4 py-3 rounded-lg border border-border bg-background text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
                  placeholder="Your full name">
              </div>
              <div>
                <label for="email" class="block text-sm font-medium text-foreground mb-2">
                  Email *
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  [(ngModel)]="contactForm.email"
                  required
                  class="w-full px-4 py-3 rounded-lg border border-border bg-background text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
                  placeholder="your@email.com">
              </div>
            </div>

            <!-- Company and Phone Row -->
            <div class="grid md:grid-cols-2 gap-4">
              <div>
                <label for="company" class="block text-sm font-medium text-foreground mb-2">
                  Company
                </label>
                <input
                  type="text"
                  id="company"
                  name="company"
                  [(ngModel)]="contactForm.company"
                  class="w-full px-4 py-3 rounded-lg border border-border bg-background text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
                  placeholder="Your company name">
              </div>
              <div>
                <label for="phone" class="block text-sm font-medium text-foreground mb-2">
                  Phone
                </label>
                <input
                  type="tel"
                  id="phone"
                  name="phone"
                  [(ngModel)]="contactForm.phone"
                  class="w-full px-4 py-3 rounded-lg border border-border bg-background text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
                  placeholder="Your phone number">
              </div>
            </div>

            <!-- Inquiry Type -->
            <div>
              <label for="inquiryType" class="block text-sm font-medium text-foreground mb-2">
                Inquiry Type
              </label>
              <select
                id="inquiryType"
                name="inquiryType"
                [(ngModel)]="contactForm.inquiryType"
                class="w-full px-4 py-3 rounded-lg border border-border bg-background text-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all">
                <option value="general">General Inquiry</option>
                <option value="sales">Sales Question</option>
                <option value="support">Technical Support</option>
                <option value="partnership">Partnership</option>
                <option value="demo">Request Demo</option>
              </select>
            </div>

            <!-- Subject -->
            <div>
              <label for="subject" class="block text-sm font-medium text-foreground mb-2">
                Subject *
              </label>
              <input
                type="text"
                id="subject"
                name="subject"
                [(ngModel)]="contactForm.subject"
                required
                class="w-full px-4 py-3 rounded-lg border border-border bg-background text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
                placeholder="What's this about?">
            </div>

            <!-- Message -->
            <div>
              <label for="message" class="block text-sm font-medium text-foreground mb-2">
                Message *
              </label>
              <textarea
                id="message"
                name="message"
                [(ngModel)]="contactForm.message"
                required
                rows="5"
                class="w-full px-4 py-3 rounded-lg border border-border bg-background text-foreground placeholder-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all resize-vertical"
                placeholder="Tell us more about your needs..."></textarea>
            </div>

            <!-- Submit Button -->
            <button
              type="submit"
              [disabled]="!contactFormRef.form.valid"
              class="w-full bg-gradient-to-r from-blue-500 to-purple-600 text-white py-4 px-6 rounded-lg font-medium hover:from-blue-600 hover:to-purple-700 transition-all shadow-lg hover:shadow-xl disabled:opacity-50 disabled:cursor-not-allowed">
              Send Message
            </button>
          </form>
        </div>
      </div>

      <!-- Contact Information -->
      <div class="space-y-8">
        <!-- Contact Details -->
        <div>
          <h2 class="text-3xl font-light text-foreground mb-8">Get in touch</h2>
          <div class="space-y-6">
            <magic-card gradientColor="#6a21a640" [isDarkTheme]="isDarkTheme">
              <div class="flex items-start space-x-4">
                <div class="w-12 h-12 bg-primary/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <svg
                    class="w-6 h-6 text-primary"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <div>
                  <h3 class="font-semibold text-foreground mb-1">Email Us</h3>
                  <p class="text-muted-foreground text-sm mb-2">
                    Send us an email and we'll respond within 24 hours
                  </p>
                  <a
                    href="mailto:hello&#64;b2bcrm.com"
                    class="text-primary hover:text-primary/80 transition-colors font-medium">
                    info&#64;b2bleadsmarket.com
                  </a>
                </div>
              </div>
            </magic-card>

            <!-- <magic-card gradientColor="#02b15140" [isDarkTheme]="isDarkTheme">
              <div class="flex items-start space-x-4">
                <div class="w-12 h-12 bg-success/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <svg
                    class="w-6 h-6 text-success"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                  </svg>
                </div>
                <div>
                  <h3 class="font-semibold text-foreground mb-1">Call Us</h3>
                  <p class="text-muted-foreground text-sm mb-2">
                    Mon-Fri from 8am to 5pm PST
                  </p>
                  <a
                    href="tel:+1-555-123-4567"
                    class="text-success hover:text-success/80 transition-colors font-medium">
                    +1 (555) 123-4567
                  </a>
                </div>
              </div>
            </magic-card> -->

            <magic-card gradientColor="#f59e0b40" [isDarkTheme]="isDarkTheme">
              <div class="flex items-start space-x-4">
                <div class="w-12 h-12 bg-warning/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <svg
                    class="w-6 h-6 text-warning"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                  </svg>
                </div>
                <div>
                  <h3 class="font-semibold text-foreground mb-1">Visit Us</h3>
                  <p class="text-muted-foreground text-sm mb-2">
                    Come say hello at our headquarters
                  </p>
                  <address class="text-warning hover:text-warning/80 transition-colors font-medium not-italic">
                    123 Business Ave<br>
                    San Francisco, CA 94105
                  </address>
                </div>
              </div>
            </magic-card>

            <!-- <magic-card gradientColor="#f1416d40" [isDarkTheme]="isDarkTheme">
              <div class="flex items-start space-x-4">
                <div class="w-12 h-12 bg-danger/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <svg
                    class="w-6 h-6 text-danger"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24">
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                  </svg>
                </div>
                <div>
                  <h3 class="font-semibold text-foreground mb-1">Live Chat</h3>
                  <p class="text-muted-foreground text-sm mb-2">
                    Chat with our support team in real-time
                  </p>
                  <button class="text-danger hover:text-danger/80 transition-colors font-medium">
                    Start Live Chat
                  </button>
                </div>
              </div>
            </magic-card> -->
          </div>
        </div>

        <!-- Office Hours -->
        <magic-card [isDarkTheme]="isDarkTheme">
          <!-- <div class="bg-card rounded-2xl shadow-xl border border-border p-6"> -->
            <h3 class="text-xl font-semibold text-foreground mb-4">Office Hours</h3>
            <div class="space-y-3 text-sm">
              <div class="flex justify-between">
                <span class="text-muted-foreground">Monday - Friday</span>
                <span class="text-foreground font-medium">8:00 AM - 6:00 PM PST</span>
              </div>
              <div class="flex justify-between">
                <span class="text-muted-foreground">Saturday</span>
                <span class="text-foreground font-medium">9:00 AM - 2:00 PM PST</span>
              </div>
              <div class="flex justify-between">
                <span class="text-muted-foreground">Sunday</span>
                <span class="text-foreground font-medium">Closed</span>
              </div>
            </div>
          <!-- </div> -->
        </magic-card>

        <!-- Quick Links -->
        <magic-card [isDarkTheme]="isDarkTheme">
          <h3 class="text-xl font-semibold text-foreground mb-4">Quick Links</h3>
          <div class="space-y-3">
            <a
              href="/auth/sign-up"
              class="flex items-center space-x-3 text-primary hover:text-primary/80 transition-colors">
              <svg
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
              </svg>
              <span>Start Free Trial</span>
            </a>
            <a
              href="#"
              class="flex items-center space-x-3 text-muted-foreground hover:text-foreground transition-colors">
              <svg
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span>Help Center</span>
            </a>
            <a
              href="#"
              class="flex items-center space-x-3 text-muted-foreground hover:text-foreground transition-colors">
              <svg
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24">
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <span>Documentation</span>
            </a>
          </div>
        </magic-card>
      </div>
    </div>
  </div>
</section>

<!-- FAQ Section -->
<section id="faq" class="py-20 px-6 lg:px-8 bg-gradient-to-br from-blue-50/50 to-purple-50/50 dark:from-blue-950/30 dark:to-purple-950/30">
  <div class="max-w-4xl mx-auto">
    <div class="text-center mb-16">
      <h2
        class="text-4xl md:text-5xl font-light text-foreground mb-6 leading-tight">
        Frequently asked
        <br />
        <span
          class="font-medium bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent"
          >questions</span
        >
      </h2>
      <p
        class="text-lg text-muted-foreground max-w-2xl mx-auto leading-relaxed">
        Can't find the answer you're looking for? Reach out to our customer support team.
      </p>
    </div>

    <div class="space-y-6">
      <div ubAccordion class="w-full space-y-3" orientation="vertical">
        <div ubAccordionItem class="border-none" value="item-1">
          <magic-card className="!p-2" [isDarkTheme]="isDarkTheme">
            <ub-accordion-trigger>
              <h3 class="text-base font-semibold text-foreground">
                How quickly can I get started with B2B CRM?
              </h3>
            </ub-accordion-trigger>
            <div ubAccordionContent>
              <p class="text-muted-foreground leading-relaxed">
                You can get started immediately! Our platform is designed for quick setup - most users are up and running within 5 minutes. We provide guided onboarding and our support team is available to help with any questions.
              </p>
            </div>
          </magic-card>
        </div>

        <div ubAccordionItem class="border-none" value="item-2">
          <magic-card className="!p-2" [isDarkTheme]="isDarkTheme">
            <ub-accordion-trigger>
              <h3 class="text-base font-semibold text-foreground">
                What integrations do you support?
              </h3>
            </ub-accordion-trigger>
            <div ubAccordionContent>
              <p class="text-muted-foreground leading-relaxed">
                You can get started immediately! Our platform is designed for quick setup - most users are up and running within 5 minutes. We provide guided onboarding and our support team is available to help with any questions.
              </p>
            </div>
          </magic-card>
        </div>

        <div ubAccordionItem class="border-none" value="item-3">
          <magic-card className="!p-2" [isDarkTheme]="isDarkTheme">
            <ub-accordion-trigger>
              <h3 class="text-base font-semibold text-foreground">
                Is my data secure with B2B CRM?
              </h3>
            </ub-accordion-trigger>
            <div ubAccordionContent>
              <p class="text-muted-foreground leading-relaxed">
                Absolutely. We use enterprise-grade security including 256-bit SSL encryption, SOC 2 compliance, and regular security audits. Your data is backed up daily and stored in secure, geographically distributed data centers.
              </p>
            </div>
          </magic-card>
        </div>

        <div ubAccordionItem class="border-none" value="item-4">
          <magic-card className="!p-2" [isDarkTheme]="isDarkTheme">
            <ub-accordion-trigger>
              <h3 class="text-base font-semibold text-foreground">
                Can I migrate data from my current CRM?
              </h3>
            </ub-accordion-trigger>
            <div ubAccordionContent>
              <p class="text-muted-foreground leading-relaxed">
                Yes! We provide free data migration services for all paid plans. Our migration specialists will work with you to ensure a smooth transition from your current system with zero data loss.
              </p>
            </div>
          </magic-card>
        </div>

        <div ubAccordionItem class="border-none" value="item-5">
          <magic-card className="!p-2" [isDarkTheme]="isDarkTheme">
            <ub-accordion-trigger>
              <h3 class="text-base font-semibold text-foreground">
                What kind of support do you offer?
              </h3>
            </ub-accordion-trigger>
            <div ubAccordionContent>
              <p class="text-muted-foreground leading-relaxed">
                We offer multiple support channels including live chat, email support, phone support, and a comprehensive help center. Enterprise customers get dedicated account managers and priority support with guaranteed response times.
              </p>
            </div>
          </magic-card>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- CTA Section -->
<section
  class="py-20 px-6 lg:px-8 bg-gradient-to-br from-blue-600 to-purple-700 relative overflow-hidden">
  <div class="absolute inset-0 bg-black/20"></div>
  <div
    class="absolute inset-0 bg-gradient-to-br from-blue-600/90 to-purple-700/90"></div>

  <!-- Background Pattern -->
  <div class="absolute inset-0 opacity-10">
    <svg
      width="100%"
      height="100%"
      viewBox="0 0 100 100"
      preserveAspectRatio="none">
      <defs>
        <pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse">
          <path
            d="M 10 0 L 0 0 0 10"
            fill="none"
            stroke="currentColor"
            stroke-width="0.5" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#grid)" />
    </svg>
  </div>

  <div class="max-w-4xl mx-auto text-center relative z-10">
    <div class="space-y-8">
      <h2 class="text-4xl md:text-5xl font-light text-white mb-6 leading-tight">
        Ready to transform your
        <br />
        <span class="font-medium">sales process?</span>
      </h2>

      <p class="text-lg text-white/90 mb-8 leading-relaxed max-w-2xl mx-auto">
        Join thousands of businesses that trust B2B CRM to accelerate their sales and build stronger customer relationships.
      </p>

      <div class="flex flex-col sm:flex-row gap-4 justify-center">
        <a
          href="/auth/sign-up"
          class="inline-flex items-center bg-white text-blue-600 px-8 py-4 rounded-lg text-base font-medium hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl">
          Start Your Free Trial
          <svg
            class="ml-2 w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 5l7 7-7 7" />
          </svg>
        </a>
        <a
          href="/mission"
          class="inline-flex items-center bg-white/20 backdrop-blur-sm text-white px-8 py-4 rounded-lg text-base font-medium border border-white/30 hover:bg-white/30 transition-all">
          Learn Our Mission
          <svg
            class="ml-2 w-4 h-4"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
          </svg>
        </a>
      </div>
    </div>
  </div>
</section>

<!-- Footer -->
<footer class="bg-background border-t border-border py-16 px-6 lg:px-8">
  <div class="max-w-7xl mx-auto">
    <div class="grid md:grid-cols-4 gap-8">
      <div>
        <div class="flex items-center space-x-2 mb-6">
          <div
            class="w-8 h-8 bg-gradient-to-br from-blue-500 to-purple-600 rounded-lg flex items-center justify-center shadow-lg">
            <svg
              class="w-5 h-5 text-white"
              fill="currentColor"
              viewBox="0 0 24 24">
              <path d="M20 6L9 17l-5-5" />
            </svg>
          </div>
          <span
            class="text-xl font-semibold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent"
            >B2B CRM</span
          >
        </div>
        <p class="text-muted-foreground mb-6">
          The complete B2B CRM solution for modern sales teams.
        </p>
        <div class="flex space-x-4">
          <a
            href="#"
            class="text-muted-foreground hover:text-foreground transition-colors">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
            </svg>
          </a>
          <a
            href="#"
            class="text-muted-foreground hover:text-foreground transition-colors">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z" />
            </svg>
          </a>
          <a
            href="#"
            class="text-muted-foreground hover:text-foreground transition-colors">
            <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path
                d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
            </svg>
          </a>
        </div>
      </div>

      <div>
        <h3 class="font-semibold text-foreground mb-4">Product</h3>
        <ul class="space-y-3 text-muted-foreground text-sm">
          <li>
            <a href="/#features" class="hover:text-foreground transition-colors"
              >Features</a
            >
          </li>
          <li>
            <a href="/#pricing" class="hover:text-foreground transition-colors"
              >Pricing</a
            >
          </li>
          <li>
            <a href="#" class="hover:text-foreground transition-colors"
              >Integrations</a
            >
          </li>
          <li>
            <a href="#" class="hover:text-foreground transition-colors">API</a>
          </li>
        </ul>
      </div>

      <div>
        <h3 class="font-semibold text-foreground mb-4">Company</h3>
        <ul class="space-y-3 text-muted-foreground text-sm">
          <li>
            <a href="/about" class="hover:text-foreground transition-colors"
              >About</a
            >
          </li>
          <li>
            <a href="#" class="hover:text-foreground transition-colors">Blog</a>
          </li>
          <li>
            <a href="#" class="hover:text-foreground transition-colors"
              >Careers</a
            >
          </li>
          <li>
            <a href="/contact" class="hover:text-foreground transition-colors"
              >Contact</a
            >
          </li>
        </ul>
      </div>

      <div>
        <h3 class="font-semibold text-foreground mb-4">Support</h3>
        <ul class="space-y-3 text-muted-foreground text-sm">
          <li>
            <a href="#" class="hover:text-foreground transition-colors"
              >Help Center</a
            >
          </li>
          <li>
            <a href="#" class="hover:text-foreground transition-colors"
              >Documentation</a
            >
          </li>
          <li>
            <a href="#" class="hover:text-foreground transition-colors"
              >Community</a
            >
          </li>
          <li>
            <a href="#" class="hover:text-foreground transition-colors"
              >Status</a
            >
          </li>
        </ul>
      </div>
    </div>

    <div
      class="border-t border-border mt-12 pt-8 text-center text-muted-foreground">
      <p>&copy; 2024 B2B CRM. All rights reserved.</p>
    </div>
  </div>
</footer>